import React, {useEffect, useRef, useState} from 'react';
import {Modal} from "react-bootstrap";
import {Player} from "@lottiefiles/react-lottie-player";
import coinJson from "../../_asset/lottie/coin.json"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

function ModalContainer({show, setShow, title, children, closeEvent, className, backdrop, closeBtn, coinEffect, centered}:
                            {show: boolean, setShow: any, title: React.ReactNode, children: React.ReactNode, closeEvent: any, className: string, backdrop: boolean, closeBtn: boolean, coinEffect: boolean, centered?: boolean}){

    function handleClose(){
        setShow(false)
        if(closeEvent){
            closeEvent()
        }
    }
    function htmlScrollHidden(){
        window.document.body.style.overflow = 'hidden'
    }
    return (
        <>
            <Modal show={show}
                   onShow={htmlScrollHidden}
                   onHide={handleClose}
                   scrollable={true}
                   centered={centered}
                   backdrop={backdrop}
                   className={`page-modal ${className}`}
            >
                <Modal.Body>
                    { title ? <Modal.Header className={"modal-title"} closeButton={true}>{title}</Modal.Header> : <></> }
                    {
                        closeBtn
                            ? <span className={'modal-close-btn'}
                                    onClick={handleClose}>
                            <FontAwesomeIcon icon={faXmark}/>
                        </span>
                            : <></>
                    }
                    {children}
                </Modal.Body>
                {
                    coinEffect ? <CoinEffect/> : <></>
                }
            </Modal>
        </>
    )
}
ModalContainer.defaultProps = {
    title: "",
    closeEvent: undefined,
    className: "",
    backdrop: true,
    closeBtn: false,
    coinEffect: false,
    centered: false
}

export default ModalContainer;


function CoinEffect(){
    const coinRef = useRef<HTMLDivElement>(null)
    const [refStyle, setRefStyle] = useState<object>({})

    useEffect(()=> {
        if(coinRef.current){
            const left = coinRef.current.getBoundingClientRect().left * -1
            const bottom = coinRef.current.getBoundingClientRect().bottom * -1.7
            setRefStyle({ "left": left, "bottom": bottom })
        }
    }, [])
    return (
        <div className={"coin-effect-popcorn"} ref={coinRef} style={refStyle}>
            {
                [...Array(12)].map((_, index)=>
                    <Player key={index}
                            className={'coinPlayer'}
                            src={coinJson}
                            autoplay={true}
                            loop={false}></Player>
                )
            }
        </div>
    )
}